import { render, staticRenderFns } from "./EditTextAlfanumerico.vue?vue&type=template&id=c07bd512&scoped=true"
import script from "./EditTextAlfanumerico.vue?vue&type=script&lang=js"
export * from "./EditTextAlfanumerico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07bd512",
  null
  
)

export default component.exports